import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useLoginStore } from './store/login'
import { reports_url } from "@/constants";
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import VueFeather from 'vue-feather'
import './assets/tailwind.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import 'skeleton-elements/css/skeleton-elements.css';
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
const loginStore = useLoginStore()

// axios.defaults.baseURL = 'localhost:3005';
axios.defaults.baseURL = reports_url;
axios.defaults.withCredentials = true;

class Dashboard extends HTMLElement {
  connectedCallback() {
    this.innerHTML = "<div id='app' class='dashb'></div>"
    app.use(loginStore)
    loginStore.autologin().then(() => {
      app.use(router)
      app.use(VueAxios, axios)
      app.use(FloatingVue)
      app.use(VueFeather)
      app.component('Multiselect', Multiselect)
      app.use(
          VueTippy,
          {
            directive: 'tippy',
          }
      )
      app.component(VueFeather.name, VueFeather);
      app.mount('#app')
    }).catch(err => {
      console.log('ups - autologin failed', err)
    })
  }
}
customElements.define("app-dashboard", Dashboard);